// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/prodotti',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"codice":"...","nome":"...","attivo":true}]}'
  },
  {
    method: 'PUT',
    endpoint: '/api/anagrafiche/prodotti/:id',
    requestBody: '{"codice":"...","nome":"...","descrizione":"...","attivo":true}',
    response: '{"success":true,"data":{"id":1}}'
  },
  {
    method: 'POST',
    endpoint: '/api/anagrafiche/prodotti',
    requestBody: '{"societaId":1,"codice":"...","nome":"...","descrizione":"..."}',
    response: '{"success":true,"data":{"id":1}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/anagrafiche/prodotti/:id',
    requestBody: null,
    response: '{"success":true}'
  },
  {
    method: 'PUT',
    endpoint: '/api/anagrafiche/prodotti/:id',
    requestBody: '{"attivo":true}',
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
